import { render, staticRenderFns } from "./ActivitysRecordDetail.vue?vue&type=template&id=a9ed9fae&scoped=true"
import script from "./ActivitysRecordDetail.vue?vue&type=script&lang=js"
export * from "./ActivitysRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivitysRecordDetail.vue?vue&type=style&index=0&id=a9ed9fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ed9fae",
  null
  
)

export default component.exports